import React from "react"

import { StyledPageContainer } from "./styled"

const PageContainer = (props) => <StyledPageContainer {...props} />

export default PageContainer
